<div class="indicators">
  <span *ngIf="isUser"
        class="avatar__indicator avatar__indicator--user"
        [ngClass]="'avatar__indicator--' + size"
        title="Entity is also a user">
    <i class="fas fa-fw fa-user"></i></span>
  <span *ngIf="spotlightIcon"
        class="avatar__indicator avatar__indicator--spotlight c-pointer"
        [ngClass]="'avatar__indicator--' + size"
        title="Entity is spotlighted!">
    <i class="fas fa-fw"
       [ngClass]="'fa-'+spotlightIcon"></i></span>

</div>
<app-assessment-circle [level]="assessmentLevel || 0"
                       [entityTypeId]="entityTypeId"
                       [size]="size"></app-assessment-circle>
